"use client";
import { useInView } from "react-intersection-observer";

export default function InViewAnimation({ children, fadeOnly=false }) {
  const { ref, inView } = useInView({
    rootMargin: '10000px 0px -15% 0px',
    triggerOnce: true,
  });
  return (
    <div ref={ref} className={`${inView ? "animShow" : ""}${fadeOnly?" fadeIn":""}`} style={{opacity: inView?1:0}}>
      {children}
    </div>
  );
}
